import React from 'react';
import PropTypes from 'prop-types';
import { clsx as cx } from 'clsx';

const variantClasses = {
	primary: 'rounded-sm bg-primary text-primary-foreground',
	secondary: 'rounded-full bg-muted text-muted-foreground',
	destructive: 'rounded-full bg-destructive/20 text-destructive',
	outline: 'rounded-full border border-border bg-transparent text-foreground'
};

function Badge(props) {
	const { label, className, variant = 'primary', style } = props;

	return (
		<span
			className={cx(
				'inline-flex items-center px-2 py-1 uppercase leading-none font-bold',
				variantClasses[variant] || variantClasses.primary,
				className
			)}
			style={{ fontSize: '0.8rem', ...style }}
		>
			{label}
		</span>
	);
}

Badge.propTypes = {
	label: PropTypes.string.isRequired,
	className: PropTypes.string,
	variant: PropTypes.oneOf(['primary', 'secondary', 'destructive', 'outline']),
	style: PropTypes.object
};

export default Badge;
